/* OT motion — scroll reveal + 3D pointer tilt w/ glare. Vanilla, performance-safe, reduced-motion aware. 2026-06-05 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;

    /* ---------- Scroll reveal (below-fold only, so nothing above the fold flashes) ---------- */
    var revealSelectors = [
      '.h-rs__copy', '.h-rs__panel',
      '.h-cp__head', '.h-cp__grid',
      '.h-prov__card',
      '.h-coi__head', '.h-coi__stat', '.h-coi__close',
      '.h-review',
      '.h-dcard',
      '.mp-panel__bio-tag',
      '.h-h2'
    ].join(',');

    var toObserve = [];
    [].forEach.call(document.querySelectorAll(revealSelectors), function (el, i) {
      if (el.getBoundingClientRect().top > vh * 0.82) {
        el.classList.add('ot-reveal');
        el.style.transitionDelay = ((i % 4) * 70) + 'ms';
        toObserve.push(el);
      }
    });

    if ('IntersectionObserver' in window && toObserve.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      toObserve.forEach(function (el) { io.observe(el); });
    } else {
      toObserve.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---------- 3D pointer tilt + glare (hover-capable pointers only) ---------- */
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    [].forEach.call(document.querySelectorAll('.rs-card, .h-panel'), function (el) {
      el.classList.add('ot-tilt');
      var glare = document.createElement('span');
      glare.className = 'ot-glare';
      el.appendChild(glare);
      var raf = null, rx = 0, ry = 0, gx = 50, gy = 50;

      function apply() {
        raf = null;
        el.style.transform = 'perspective(800px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-10px) scale(1.025)';
        glare.style.background = 'radial-gradient(circle at ' + gx.toFixed(1) + '% ' + gy.toFixed(1) + '%, rgba(255,255,255,0.45), rgba(255,255,255,0) 55%)';
      }
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        ry = px * 12; rx = -py * 12;
        gx = (px + 0.5) * 100; gy = (py + 0.5) * 100;
        el.classList.add('is-tilting');
        if (!raf) raf = requestAnimationFrame(apply);
      }, { passive: true });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-tilting');
        el.style.transform = '';
      });
    });

    /* ---------- Magnetic + sheen primary CTAs ---------- */
    var ctaSel = '.h-hero__cta--primary, .h-rs__cta, .h-cp__cta, .h-coi__cta, .mp-hero__cta';
    [].forEach.call(document.querySelectorAll(ctaSel), function (btn) {
      btn.classList.add('ot-magnetic');
      var raf = null, tx = 0, ty = 0;
      function apply() {
        raf = null;
        btn.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + (ty - 2).toFixed(1) + 'px)';
      }
      btn.addEventListener('pointermove', function (ev) {
        var r = btn.getBoundingClientRect();
        tx = ((ev.clientX - r.left) / r.width - 0.5) * 10;
        ty = ((ev.clientY - r.top) / r.height - 0.5) * 6;
        if (!raf) raf = requestAnimationFrame(apply);
      }, { passive: true });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });

    /* ---------- Count-up numbers (auto-skips ranges / non-numeric) ---------- */
    var re = /^(\D*)([\d,]+(?:\.\d+)?)(\D*)$/;
    var counters = [];
    [].forEach.call(document.querySelectorAll('.h-stats-bar__num, .h-coi__num'), function (el) {
      var m = el.textContent.trim().match(re);
      if (!m) return;
      var raw = m[2];
      el.__cu = {
        prefix: m[1], suffix: m[3],
        decimals: raw.indexOf('.') > -1 ? raw.split('.')[1].length : 0,
        comma: raw.indexOf(',') > -1,
        target: parseFloat(raw.replace(/,/g, ''))
      };
      function fmt0(c) { return c.prefix + (c.comma ? '0' : (c.decimals ? (0).toFixed(c.decimals) : '0')) + c.suffix; }
      el.textContent = fmt0(el.__cu);
      counters.push(el);
    });
    function fmt(n, c) {
      var s = c.comma ? Math.round(n).toLocaleString('en-US') : (c.decimals ? n.toFixed(c.decimals) : Math.round(n).toString());
      return c.prefix + s + c.suffix;
    }
    function runCount(el) {
      var c = el.__cu, dur = 1300, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(c.target * e, c);
        if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(c.target, c);
      }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window && counters.length) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(runCount);
    }

    /* ---------- Kinetic split-word headings (dark inside-panel) ---------- */
    var kEls = [].slice.call(document.querySelectorAll('.mp-panel__heading-primary, .mp-panel__heading-muted'));
    kEls.forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var sp = document.createElement('span');
        sp.className = 'ot-word';
        sp.textContent = w;
        sp.style.transitionDelay = (i * 45) + 'ms';
        el.appendChild(sp);
        el.appendChild(document.createTextNode(' '));
      });
    });
    if ('IntersectionObserver' in window && kEls.length) {
      var kio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('words-in'); kio.unobserve(e.target); } });
      }, { threshold: 0.2 });
      kEls.forEach(function (el) { kio.observe(el); });
    } else {
      kEls.forEach(function (el) { el.classList.add('words-in'); });
    }
    [].forEach.call(document.querySelectorAll('.mp-panel__heading'), function (h) {
      var sec = h.closest('section') || h.parentElement, raf = null, tx = 0, ty = 0;
      function ap() { raf = null; h.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px)'; }
      sec.addEventListener('pointermove', function (ev) {
        var r = sec.getBoundingClientRect();
        tx = ((ev.clientX - r.left) / r.width - 0.5) * 16;
        ty = ((ev.clientY - r.top) / r.height - 0.5) * 10;
        if (!raf) raf = requestAnimationFrame(ap);
      }, { passive: true });
      sec.addEventListener('pointerleave', function () { h.style.transform = ''; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
